import bootLayout from 'static/script/app/boot/boot-layout'

export default initData => {
    bootLayout(initData);
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/category-list.js